import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { confirmForgotPassword } from '../services/authService';

export const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is missing. Please start the password reset process again.');
            return;
        }

        setError('');
        setLoading(true);

        try {
            await confirmForgotPassword(email, code, newPassword);
            // Redirect to login page on success
            navigate('/login', { 
                state: { message: 'Password has been reset successfully. Please log in with your new password.' }
            });
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    if (!email) {
        return (
            <div className="auth-container">
                <h2>Error</h2>
                <p>No email provided. Please start the password reset process again.</p>
                <button onClick={() => navigate('/forgot-password')}>
                    Go to Forgot Password
                </button>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <h2>Reset Password</h2>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="code">Reset Code</label>
                    <input
                        type="text"
                        id="code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="newPassword">New Password</label>
                    <input
                        type="password"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={8}
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'Resetting...' : 'Reset Password'}
                </button>
            </form>
            <p>
                <button onClick={() => navigate('/forgot-password')}>
                    Request New Code
                </button>
            </p>
        </div>
    );
}; 